// TODO controllare
export enum EStatusCode {
    Undefined = 0,
    Ok = 200,
    NoContent = 204,
    ProjectNotExist = 250,
    ProjectExistButAuthorNotExist = 251,
    EntityNotExist = 252,
    EntityExistWithNoImages = 253,
    NotAuthorized = 401,
    BadRequest = 404,
    ServerError = 500,
    CalculationError = 550,
    ProjectNotInserted = 551,
    FileNotUploaded = 552,
    EntityNotInserted = 553,
    EntityNotUpdated = 554,
    EntityNotDeleted = 555,
    DocumentNotDeleted = 556,
}
